import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../../utils/IDS";
import { GET, POST } from "../../../utils/Methods";
import { APIS, WEB_APIS } from "../../../utils/APIS";
import Cookies from "js-cookie";

// Auth - Login
export const AuthLogin = createAsyncThunk(
    "auth/login/post",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(WEB_APIS.Auth, data);
            if (res.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);



// GET Auth - Login
export const GETAuthUser = createAsyncThunk(
    "auth/web-login/get",
    async (_, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Auth}/get-user`);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const dashboard = createAsyncThunk(
    "dashbord/get",
    async (_, { rejectWithValue }) => {
        try {
            const res = await GET(APIS.Dashboard);

            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const AuthLogOut = createAsyncThunk(
    // Auth - Logout
    "auth/logout",
    async (_, { rejectWithValue }) => {
        try {
            // const res = await GET(APIS.Auth);
            Cookies.remove("khadyalay_admin_security", { path: "/" });
            Cookies.remove("khadyalay_web_security", { path: "/" });
            return {
                data: {},
                token: null,
                role: null,
                permissions: null,
                isLogin: false,
                error: null,
            };
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const UpdateBusinessData = createAsyncThunk(
    "auth/updateBusiness",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Auth}/business-update`, data);

            if (res.success) {

                return res; // The new expense object
            }

        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);

export const Slice = createSlice({
    name: "auth",
    initialState: {
        data: {},
        token: null,
        role: null,
        permissions: null,
        isLogin: false,
        status: IDS.SLICESTATUS.Idle,
        error: null,
        all_permission: {},
        all_dashboard: {},
    },
    reducers: {
        // Add any additional reducers if needed
    },
    extraReducers: (builder) => {
        builder


            .addCase(UpdateBusinessData.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(UpdateBusinessData.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                // state.data.unshift(action.payload.data);
            })
            .addCase(UpdateBusinessData.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            // .addCase(AuthLogin.pending, (state) => {
            //     state.status = IDS.SLICESTATUS.Loading;
            // })
            // .addCase(AuthLogin.fulfilled, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Succeeded;
            //     state.token = action.payload.data.token;
            //     state.role = action.payload.data.role;
            //     state.permissions = action.payload.data.permissions;
            //     state.isLogin = true;
            // })
            // .addCase(AuthLogin.rejected, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Failed;
            //     state.error = action.payload;
            //     state.isLogin = false;
            // })
            .addCase(GETAuthUser.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GETAuthUser.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload.data;
                state.role = action.payload.data.role;
                state.permissions = action.payload.data.permissions;
                state.isLogin = true;
            })
            .addCase(GETAuthUser.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
                // state.isLogin = false;
                state.data = {};
                state.token = null;
                state.role = null;
                state.permissions = null;
                state.isLogin = false;
            })
            //
            // .addCase(AuthLogOut.pending, (state) => {
            //     state.status = IDS.SLICESTATUS.Loading;
            // })
            // .addCase(AuthLogOut.fulfilled, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Succeeded;
            //     state.data = {};
            //     state.token = null;
            //     state.role = null;
            //     state.permissions = null;
            //     state.isLogin = false;
            // })
            // .addCase(AuthLogOut.rejected, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Failed;
            //     state.error = action.payload;
            //     state.isLogin = false;
            // })

            .addCase(dashboard.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(dashboard.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;


                state.all_dashboard = action.payload?.data;

            })
            .addCase(dashboard.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
                state.isLogin = false;
            })



    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
